export default {"src":"https://marketing-edge-assets.lemonade.com/_next/static/media/arrow.d6f24d09.svg","height":32,"width":18,"blurWidth":0,"blurHeight":0};